import React, { Fragment, useState, useEffect, useCallback, useRef, useMemo } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardBody, Nav, NavItem, NavLink, Button, CardText, UncontrolledTooltip } from 'reactstrap';
import useKeyPress from 'hooks/useKeyPress';

function ItemDetail({ isOpen, title, tabs = [], defaultTab, onClose, onRefresh, ...rest }) {
  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const isEscapeKeyPressed = useKeyPress('Escape');
  const hasMultipleTabs = tabs.length > 1;

  const handleChangeTab = useCallback((tab) => {
    setCurrentTab(tab)
  }, [])

  useEffect(() => {
    setCurrentTab(tabs.find(tab => tab.name === defaultTab) ?? tabs[0])
  }, [tabs, defaultTab])

  useEffect(() => {
    if (isEscapeKeyPressed) {
      // onClose()
    }
  }, [isEscapeKeyPressed, onClose])

  // if (!isOpen) {
  //   return null;
  // }

  return (
    <Card
      className={clsx('pull-right position-fixed transition-all')}
      style={{
        // width: isOpen && currentTab?.fullWidth ? 'calc(100% - 70px)' : undefined,
        width: isOpen && currentTab?.fullWidth ? 'calc(100% - 80px)' : '550px',
        height: 'calc(100% /*- 57px*/)',
        top: 0,
        zIndex: 100,
        right: isOpen ? '0' : (currentTab?.fullWidth ? '-100%' : '-550px'),
      }}>
      <CardHeader>
        <div className="d-flex">
          <UncontrolledTooltip placement="auto" target="title-item-detail">{title}</UncontrolledTooltip>
          <div className="align-self-center text-break text-truncate" id="title-item-detail" style={{
              maxWidth: '85%'
          }}>
            {title}
          </div>
          <div className="ml-auto">
            {onRefresh &&
              <Button color="light" onClick={onRefresh} size="sm">
                <i className="fas fa-sync text-success"></i>
              </Button>
            }
            <Button color="light" onClick={onClose} size="sm">
              <i className="fas fa-times"></i>
            </Button>
          </div>
        </div>
      </CardHeader>

      {hasMultipleTabs &&
        <Nav tabs fill>
          {tabs?.map((tab) => (
            <TabItem
              key={tab.name}
              tab={tab}
              onClick={handleChangeTab}
              restProps={rest}
              isActive={currentTab.name === tab.name}
            />
          ))
          }
        </Nav>
      }
      <currentTab.Component currentTab={currentTab} onClose={onClose} onRefresh={onRefresh}  {...rest} />

    </Card>
  )
}

export default ItemDetail;

function TabItem({ tab = {}, isActive, onClick, restProps }) {
  const { name, icon, img, brand } = tab;
  const { t } = useTranslation()

  const handleClick = useCallback(() => {
    onClick({ ...tab, isActive })
  }, [tab, isActive, onClick])

  const tooltip = useMemo(() => tab.tooltip?.({ t, ...restProps }), [t, tab, restProps])

  if (tab?.shouldShow?.(restProps) === false) {
    return null;
  }

  return (
    <NavItem
      onClick={handleClick}
      title={tooltip}
    >
      <NavLink className={clsx({ active: isActive })}>
        {brand && <i className={`fab fa-${brand}`} />}
        {icon && <i className={`fas fa-${icon}`} />}
        {img && <img src={img} alt={name} width="10px" />}
      </NavLink>
    </NavItem>
  )
}